var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "app-breadcrumb", attrs: { "aria-label": "Breadcrumb" } },
    [
      _c(
        "transition-group",
        {
          staticClass: "app-breadcrumb__list",
          attrs: { tag: "ol", name: "breadcrumb" },
        },
        _vm._l(_vm.levelList, function (item, index) {
          return _c(
            "li",
            { key: item.path, staticClass: "app-breadcrumb__item" },
            [
              index > 0
                ? _c("svg-icon", {
                    attrs: {
                      "icon-class": "caret-right-bold",
                      "class-name":
                        index === _vm.levelList.length - 1
                          ? "app-breadcrumb__separator app-breadcrumb__separator--current"
                          : "app-breadcrumb__separator",
                    },
                  })
                : _vm._e(),
              index === _vm.levelList.length - 1
                ? _c(
                    "span",
                    {
                      staticClass: "app-breadcrumb__current",
                      attrs: { "aria-current": "page" },
                    },
                    [_vm._v(_vm._s(_vm.getTitle(item.meta.title)))]
                  )
                : item.redirect === "noRedirect"
                ? _c("span", { staticClass: "app-breadcrumb__text" }, [
                    _vm._v(_vm._s(_vm.getTitle(item.meta.title))),
                  ])
                : _c(
                    "a",
                    {
                      staticClass: "app-breadcrumb__link",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleLink(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.meta.title))]
                  ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }